import * as React from 'react';
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
export const Screen1 = ({ sravni }) => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel padding={"30px 0 0"} noLink={sravni}/>
        <div className={screen1.info}>
          <h1>
            <small>ОНЛАЙН Курс-интенсив:</small><br/>
            Запоминание<br/><span>1000 иностранных слов </span><br/>за неделю
          </h1>

          <p>
            Вы научитесь запоминать <b>от&nbsp;300&nbsp;до&nbsp;1&nbsp;000</b> новых иностранных слов за день
            и запомните за курс <b>от&nbsp;1&nbsp;000&nbsp;до&nbsp;2&nbsp;500</b> нужных Вам слов.
          </p>

          <a href="#purchase" className={`btn ${main.btn}`}>Хочу научиться</a>
        </div>
      </div>
    </header>
  );
};
